export {
  InvitationAdmin,
  type InvitationAdminOutcome,
  type InvitationAdminProps,
} from "./InvitationAdmin";
export {
  InvitationLanding,
  type InvitationLandingProps,
  type InvitationLandingState,
} from "./InvitationLanding";

export const invitationStylesheet = `
.invitation-admin,
.invitation-landing {
  display: grid;
  gap: var(--space-4);
}

.invitation-admin ul {
  display: grid;
  gap: var(--space-3);
  list-style: none;
  margin: 0;
  padding: 0;
}
`;
